import { render, staticRenderFns } from "./StockReceive.vue?vue&type=template&id=4a5b9912&"
import script from "./StockReceive.vue?vue&type=script&lang=js&"
export * from "./StockReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports